import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { formatNumber } from "../Utils/utils";
import { defaultFormShape } from "../Utils/constants";
import { imgBas64 } from "../Utils/constants";
import moment from "moment";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const generatePdfQuoteAS = data => {
  const years = data.datosCotizacion.periodo;
  const dateInit = moment.unix(data.fechaCreacionUnix).format('DD/MM/YYYY');
  const dateExpiration = moment(dateInit, 'DD/MM/YYYY').add('days', 7).format('DD/MM/YYYY');
  const dateEnd = moment(dateInit, 'DD/MM/YYYY').add('years', years).format('DD/MM/YYYY');
  const birthDate = data.datosCliente.nacimiento;
  const age = moment().diff(moment(birthDate, 'DD/MM/YYYY'), 'years');
  const toppings = data.cobertura;
  const codeAdvisor = data.codigoAsesor || '';
  let rescue = data.rescate.map(i => {
    let result = formatNumber.new(parseFloat(i.amount).toFixed(2));
    return [i.years, result];
  });
  let rescueRate = data.rescate.map(i => {
    return [i.years, i.rate < 0 ? "(*)" : `${i.rate}%`];
  });

  if (rescue[rescue.length -1] && Number(data.datosCotizacion.periodo) !== defaultFormShape.period6months) {
    rescue.splice(rescue.findIndex(res => res[0] === defaultFormShape.period6months), 1)
    rescueRate.splice(rescueRate.findIndex(res => res[0] === defaultFormShape.period6months), 1)
  }

  let rateWhenZeroYearNegative = '';
  const isZeroYearNegative = () => {
    const tmp = data.rescate.filter(i => parseFloat(i.rate) < 0);
    if (tmp.length > 0) {
      rateWhenZeroYearNegative = tmp[0].rate * -1;
      return true;
    }
    return false;
  }
  // const getCoverageById = (id) => {
  //   const item = toppings.find(el => el.idTopping === id);
  //   if (!item) {
  //     return 0;
  //   }
  //   const amount = item.price || 0;
  //   return amount;
  // };

  const coverages = {
    '002': 'Fallecimiento',
    '001': 'Sobrevivencia',
    '004': 'Indemnización adicional por fallecimiento accidental',
    '003': 'Indemnización Oncológica',
  };

  let arrCoverage = [[
    { text: 'Cobertura', fontSize: 10, color: '#545868', },
    { text: 'Moneda', fontSize: 10, color: '#545868', },
    { text: 'Suma Asegurada', fontSize: 10, color: '#545868', },
  ]];

  for (const [id, name] of Object.entries(coverages)) {
    const item = toppings.find(el => el.idTopping === id);
    if (item) {
      const amount = item.price || 0;
      arrCoverage.push([name, data.datosCotizacion.moneda.iso, amount]);
    }
  }

  const summary = {
    '001': 'Por sobrevivencia',
    '003': 'Por diagnóstico de cáncer',
    '004': 'Por fallecimiento accidental',
    '002': 'Por fallecimiento natural',
  };

  let arrSummary = [];
  for (const [id, name] of Object.entries(summary)) {
    const item = toppings.find(el => el.idTopping === id);
    if (item) {
      if (id === '001') {
        arrSummary.push([
          { text: 'En caso de sobrevivencia al periódo contratado, Ud. recibirá:', fontSize: 10, color: '#545868', },
          '', ''
        ]);
      }
      else if (id === '003') {
        arrSummary.push([
          { text: 'En caso le detecten cáncer, Ud. recibirá:', fontSize: 10, color: '#545868', },
          '', ''
        ]);
      }
      else if (id === '004') {
        arrSummary.push([
          { text: 'En caso Ud. faltara, sus beneficiarios recibirán:', fontSize: 10, color: '#545868', },
          '', ''
        ]);
      }
      const amount = item.price || 0;
      arrSummary.push([
        { text: name, margin: [10, 0, 0, 0], },
        data.datosCotizacion.moneda.iso,
        amount
      ]);
    }
  }

  // const logo = 'data:image/png;base64,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';
  const header = {
    margin: 8,
    background: 'blue',
    columns: [
      {
        table: {
          widths: ['100%'],
          body: [
            [
              {
                image: imgBas64.logo,
                width: 100,
                margin: [15, 0, 0, 0],
              },
            ]
          ]
        },
        layout: 'noBorders'
      }
    ]
  };

  let gender = ['', ''];
  if (data.datosCliente.datosParticulares) {
    gender = ['Sexo:', `${data.datosCliente.datosParticulares.sexo === 'F' ? 'Femenino' : 'Masculino'}`];
  }

  var docDefinition = {
    header,
    content: [
      {
        text: [
          { text: 'Documento de cotización de ', fontSize: 18, color: '#545868;' },
          { text: 'Ahorro Seguro', fontSize: 18, color: '#f0353b' }
        ],
        margin: [0, 20, 0, 5],
      },
      {
        text: `Vigencia del ${dateInit} hasta ${dateExpiration}`,
        color: '#545868;',
        fontSize: 10,
        margin: [0, 0, 0, 5],
      },
      {
        style: "tableTitle",
        table: {
          widths: [70, 100, 20, 40, 190],
          body: [
            [
              'Nº Cotización:',
              data.numCotizacion || '-',
              '',
              'Asesor:',
              data.asesor.toUpperCase(),
            ],
            [
              'Nº Simulación:',
              data.numSimulacion,
              '',
              'Código:',
              codeAdvisor
            ],
          ]
        },
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 5; },
          paddingBottom: function (i, node) { return 5; },
        },
      },
      {
        text: 'Datos del asegurado titular',
        color: '#545868;',
        fontSize: 14,
        margin: [0, 10, 0, 5],
      },
      {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 520,
            h: 120,
            r: 5,
            lineColor: '#D4D5E8',
          },
        ],
      },
      {
        style: "tableContent",
        table: {
          // widths: [70, 100, 20, 40, 190],
          body: [
            ['Nombre:', data.datosCliente.nombres.toUpperCase()],
            ['Doc.Identidad:', `${data.datosCliente.tipoDoc.nombre} ${data.datosCliente.documento}`],
            ['Edad:', age],
            ['Fecha Nacimiento:', birthDate],
            gender,
          ]
        },
        layout: 'headerLineOnly',
        absolutePosition: { x: 60, y: 210 }
      },
      {
        text: 'Datos de la cotización',
        color: '#545868;',
        fontSize: 14,
        margin: [0, 25, 0, 5],
      },
      {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 520,
            h: 160 + 20 * toppings.length,
            r: 5,
            lineColor: '#D4D5E8',
          },
        ],
        absolutePosition: { x: 40, y: 355 }
      },
      {
        text: 'Datos de inversión',
        color: '#545868;',
        fontSize: 12,
        margin: [10, 10, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [70, 80, 50, 100, 70],
          body: [
            ['Prima:', data.datosCotizacion.prima, '', 'Moneda:', data.datosCotizacion.moneda.iso],
            ['Plazo:', Number(data.datosCotizacion.periodo) === defaultFormShape.period6months ? '6 meses' : `${data.datosCotizacion.periodo} año${Number(data.datosCotizacion.periodo) > 1 ? 's': ''}`, '', 'Vencimiento Póliza:', dateEnd],
            ['TREA:', `${data.datosCotizacion.tasa}%`, '', '', ''],
          ]
        },
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 3; },
          paddingBottom: function (i, node) { return 3; },
        },
        margin: [20, 10, 0, 5],
      },
      {
        text: 'Datos del seguro',
        color: '#545868;',
        fontSize: 12,
        margin: [10, 15, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [250, 50, 90, 100],
          body: arrCoverage,
          // [
          //   [
          //     {text:'Cobertura', fontSize: 10, color: '#545868',},
          //     {text:'Moneda', fontSize: 10, color: '#545868',},
          //     {text:'Suma Asegurada', fontSize: 10, color: '#545868',},
          //   ],
          //   ['Fallecimiento', data.datosCotizacion.moneda.iso, getCoverageById('002')],
          //   ['Sobrevivencia', data.datosCotizacion.moneda.iso, getCoverageById('001')],
          //   ['Indemnización adicional por fallecimiento accidental', data.datosCotizacion.moneda.iso, getCoverageById('004')],
          //   ['Indemnización Oncológica ', data.datosCotizacion.moneda.iso, getCoverageById('003')],
          // ]
        },
        // layout: 'headerLineOnly',
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 3; },
          paddingBottom: function (i, node) { return 3; },
        },
        margin: [20, 5, 0, 5],
      },
      {
        text: `RIMAC deja expresa constancia que ninguno de sus Asesores de Ventas están autorizados a recibir suma alguna de dinero ya sea por concepto de primas, comisiones, gastos, o cualquier otro concepto. RIMAC no asume ningiuna responsabilidad por cualquier pago, ya sea en efectivo o bajo cualquier otra modalidad que sea entregado a sus Asesores de Ventas.`,
        color: '#545868;',
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 30, 0, 0],
      },
      {
        text: `La aceptación de los términos de la presente propuesta, es requisito esencial para que el potencial contratante acceda a la posibilidad de suscribir la Solicitud de Seguro. En caso que, luego de suscrita la Solicitud de Seguro, el potencial contratante no cumpla con los requisitos de asegurabilidad establecidos para el presente producto, este documento quedará sin efecto alguno y no olbiga a RIMAC. La emisión de la presenta propuesta no es señal de aceptación del riesgo por parte de RIMAC SEGUROS. La aceptación del riesgo se evidencia con la emisión de la Póliza de Seguro respectiva.`,
        color: '#545868;',
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 10, 0, 5],
        pageBreak: 'after',
      },
      // Next page
      {
        text: 'Resumen integral de protección',
        color: '#545868;',
        fontSize: 14,
        margin: [0, 20, 0, 5],
      },
      {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 520,
            h: 20 + 40 * toppings.length,
            r: 5,
            lineColor: '#D4D5E8',
          },
        ],
        absolutePosition: { x: 40, y: 85 }
      },
      {
        style: "tableContent",
        table: {
          widths: [320, 50, 90, 100],
          body: arrSummary,
          // [
          //   [
          //     {text:'En caso de sobrevivencia al periódo contratado, Ud. recibirá:', fontSize: 10, color: '#545868',},
          //     '', ''
          //   ],
          //   [
          //     {text:'Por sobrevivencia', margin: [10, 0, 0, 0],},
          //     data.datosCotizacion.moneda.iso, 
          //     getCoverageById('001')
          //   ],
          //   [
          //     {text:'En caso le detecten cáncer, Ud. recibirá:', fontSize: 10, color: '#545868',},
          //     '', ''
          //   ],
          //   [
          //     {text:'Por diagnóstico de cáncer', margin: [10, 0, 0, 0],},
          //     data.datosCotizacion.moneda.iso, 
          //     getCoverageById('003')
          //   ],
          //   [
          //     {text:'En caso Ud. faltara, sus beneficiarios recibirán:', fontSize: 10, color: '#545868',},
          //     '', ''
          //   ],
          //   [
          //     {text:'Por fallecimiento accidental', margin: [10, 0, 0, 0],},
          //     data.datosCotizacion.moneda.iso, 
          //     getCoverageById('004')
          //   ],
          //   [
          //     {text:'Por fallecimiento natural', margin: [10, 0, 0, 0],},
          //     data.datosCotizacion.moneda.iso, 
          //     getCoverageById('002')
          //   ],
          // ]
        },
        // layout: 'headerLineOnly',
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 4; },
          paddingBottom: function (i, node) { return 4; },
        },
        margin: [30, 20, 0, 5],
      },
      {
        text: 'El pago de la prima se realizará mediante transferencia bancaria o depósito en las cuentas de Rimac. Toda comisión por transferencia y/o cualquier otro gasto que demande la transferencia de los fondos a RIMAC, por concepto de prima, serán de cuenta y cargo del CONTRATANTE.',
        color: '#545868;',
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 30, 0, 0],
      },
      {
        text: 'Los asegurados mayores de 70 años o quienes marcaron Sí en la Declaración Personal de Salud sólo tendrán las coberturas de fallecimiento y sobrevivencia. La Suma Asegurada de Fallecimiento corresponderá a la Prima Única pagada más los intereses ganados y liquidados a la fecha en que se haya producido el fallecimiento del Asegurado.',
        color: '#545868;',
        fontSize: 10,
        lineHeight: 1.2,
        margin: [0, 10, 0, 0],
      },
      {
        text: 'Cuadro de Valores',
        color: '#545868;',
        fontSize: 14,
        margin: [0, 10, 0, 5],
      },
      {
        canvas: [
          {
            type: 'rect',
            x: 0,
            y: 0,
            w: 520,
            h: 410,
            r: 5,
            lineColor: '#D4D5E8',
          },
        ],
        absolutePosition: { x: 40, y: 245 + 40 * toppings.length }
      },
      {
        text: 'Valores de Rescate',
        color: '#545868;',
        fontSize: 12,
        margin: [20, 20, 0, 5],
      },
      {
        text: 'Valores de Rescate por año cumplido de vigencia:',
        color: '#545868;',
        fontSize: 10,
        margin: [20, 5, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [50, 200],
          body: [
            [
              { text: 'Año', fontSize: 10, color: '#545868', },
              { text: 'Rescate', fontSize: 10, color: '#545868', },
            ],
            ...rescue,
          ]
        },
        // layout: 'headerLineOnly',
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 3; },
          paddingBottom: function (i, node) { return 3; },
        },
        margin: [45, 10, 0, 5],
      },
      {
        text: 'Tabla de Tasas de Rentabilidad Efectiva Anual',
        color: '#545868;',
        fontSize: 12,
        margin: [20, 20, 0, 5],
      },
      {
        text: 'Aplicable para el cálculo del valor de rescate solicitado antes del fin de vigencia de la póliza.',
        color: '#545868;',
        fontSize: 10,
        margin: [20, 5, 0, 5],
      },
      {
        style: "tableContent",
        table: {
          widths: [50, 200],
          body: [
            [
              { text: 'Año', fontSize: 10, color: '#545868', },
              { text: 'TREA', fontSize: 10, color: '#545868', },
            ],
            ...rescueRate,
          ]
        },
        // layout: 'headerLineOnly',
        layout: {
          hLineWidth: function hLineWidth(i) { return 0; },
          vLineWidth: function vLineWidth(i) { return 0; },
          paddingLeft: function (i, node) { return 0; },
          paddingRight: function (i, node) { return 0; },
          paddingTop: function (i, node) { return 3; },
          paddingBottom: function (i, node) { return 3; },
        },
        margin: [45, 10, 0, 5],
      },
      {
        text: isZeroYearNegative() ? `(*) Todo rescate que se solicite antes de haber cumplido el primer año desde la contratación de la póliza, tendrá un descuento por concepto de costo de gasto de administración del ${rateWhenZeroYearNegative}% sobre el capital invertido.` : "",
        color: '#545868;',
        fontSize: 10,
        margin: [20, 5, 20, 5],
        lineHeight: 1.2
      }
    ],
    styles: {
      pdfHeader: {
        background: '#ef3340',
      },
      tableTitle: {
        margin: [0, 5, 0, 5],
        fontSize: 10,
      },
      tableContent: {
        fontSize: 10,
      },
    }
  };

  pdfMake.createPdf(docDefinition).open();
};
